export { ASSIGN_TO_ADDON } from './assignToAddon';
